import type { Directive, DirectiveBinding } from 'vue';
import store from '@user-center/store'

export function hasPermission(permCodes: string[]) {
  const route = store.getters.route
  const routeCode = route.meta.codeAlias || route.meta.code || route.meta.parentCode
  const roleMenus = store.getters.roleMenus
  const menu = roleMenus.find(item => item.code === routeCode)
  const perms = menu.menuButtonList?.map(item => item.buttonCode)
  return perms?.some(item => permCodes.includes(item))
}

export const permission: Directive = {
  mounted(el: Element, binding: DirectiveBinding<any>) {
    const { value: permCodes } = binding

    if (permCodes === undefined)
      return

    if (!hasPermission(permCodes)) {
      el.parentNode?.removeChild(el)
    }
  },
}
